import React from "react";
import Typewriter from "typewriter-effect";
import filter from "../assets/images/filter-icon.svg";
import backArrow from "../assets/images/arrow_icon.png";

const ScriptResponse = ({ finalResponse, backhandler }) => {
  return (
    <div className="container cl-main-container">
      <div className="card p-3 bg-transparent cl-main-card">
        <div className="card cl-secondary-card">
          <div className="card-body p-4">
            <div className="cl-filter-icon">
              <label>
                <span>
                  <img className="img-fluid" src={filter} alt="Filter" />
                </span>
                Conversion Lab
              </label>
              <hr className="cl-heading-border" />
            </div>
            <div className="form-floating mt-3">
              <div className="p-4 cl-internal-area-container set-height">
                {finalResponse ? (
                  <Typewriter
                    options={{
                      delay: 25, // Lower value for faster typing
                      cursor: "", // This sets an initial cursor character
                    }}
                    onInit={(typewriter) => {
                      typewriter
                        .typeString(finalResponse)
                        .callFunction(() => {
                          document.querySelector(
                            ".Typewriter__cursor"
                          ).style.display = "none"; // This hides the cursor
                        })
                        .start();
                    }}
                  />
                ) : (
                  "Loading..."
                )}
              </div>
            </div>
            <div className="mt-2">
              <button
                type="button"
                onClick={backhandler}
                className="btn cl-goback-btn"
              >
                <span className="me-1 align-items-center">
                  <img
                    className="img-fluid"
                    src={backArrow}
                    width={15}
                    alt="Go Back"
                  />
                </span>{" "}
                Go Back
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScriptResponse;
